import { ref } from 'vue'

export function useStripePayment() {
    const stripePublicConfig = ref({
        onlinePaymentEnabled: false,
        depositEnabled: false,
        depositType: 'percentage',
        depositValue: 30,
        currency: 'EUR',
        stripePublishableKey: null
    })

    const fetchStripePublicConfig = async () => {
        try {
            const res = await fetch('/api/stripe/public-config')
            if (!res.ok) return
            const json = await res.json()
            const payload = json.data ?? json
            stripePublicConfig.value = { ...stripePublicConfig.value, ...payload }
        } catch {
            // silently fall back to defaults (cash-only mode)
        }
    }

    const createPaymentIntent = async (bookingData, paymentType) => {
        const res = await fetch('/api/stripe/create-payment-intent', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...bookingData, paymentType })
        })
        if (!res.ok) {
            const err = await res.json().catch(() => ({}))
            const error = new Error(err.error || err.data?.error || 'Failed to create payment intent')
            // Keep the machine-readable code + details so the caller can translate known rejections
            // (SAME_DAY_LEAD_TIME, SITE_OFFLINE: the latter also sends it as `code`).
            error.code = err.code || err.error || err.data?.error || null
            error.leadTimeMinutes = err.leadTimeMinutes ?? err.data?.leadTimeMinutes
            // Staff skills: SLOT_UNAVAILABLE / THERAPIST_UNAVAILABLE carry reason NO_SKILLED_THERAPIST / NOT_SKILLED.
            error.reason = err.reason ?? err.data?.reason ?? null
            throw error
        }
        const json = await res.json()
        return json.data ?? json
    }

    return { stripePublicConfig, fetchStripePublicConfig, createPaymentIntent }
}
